import React from 'react';
import { ScintillaofArt2026 } from '../views';


const BlogNewsroomPage = () => {

return <ScintillaofArt2026/>
};

export default BlogNewsroomPage;